import React from 'react';
import './FootbarStyles.css';

function Footbar() {
  return (
    <div className="footbar-div">
      <div className="footbar-espanol">
        <span>
          <img src="/world-icon.svg" alt="world" />
        </span>{' '}
        Español
      </div>
      <hr />
      <div>
        <span className="footbar-secure">
          <img src="/lock-icon.svg" alt="lock" />
          Secure
        </span>
        <span className="footbar-copyright-2">© 2024 Snap Finance LLC</span>
      </div>
      <div className="footbar-version">v 1.0.0</div>
    </div>
  );
}

export default Footbar;
